module.exports = __webpack_public_path__ + "img/Group 40.d219b221.svg";